import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { EFFECTS } from "./effects/index";
import { reducer } from "./reducers/shared.reducer";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature("sharedFeatureModule", { sharedState: reducer }),
    EffectsModule.forFeature(EFFECTS),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/shared/shared.module.ts